export default {
    PtHeaderWidgetCaseTime: {
        tooltip: 'タイマー',
    },
};
